import React from "react";
import { Outlet } from "react-router-dom";
import { StyledPaymentCheckoutLayout } from "@/components/layouts/PaymentCheckoutLayout/PaymentCheckoutLayout.styled.ts";

const PaymentCheckoutLayout: React.FunctionComponent = () => {
  return (
    <StyledPaymentCheckoutLayout>
      <Outlet />
    </StyledPaymentCheckoutLayout>
  );
};

export default PaymentCheckoutLayout;
